import React, { PropsWithChildren, useContext } from 'react';
import { Modal, SpinnerSize } from '@fluentui/react';
import { Spinner } from '@fluentui/react';
import { commonModalStyles } from '../../../Common/util/CommonStyles';
import { ThemeContext } from '../../models/ThemeContext';
import { getThemeFromString } from '../../../Common/util/localStorageUtils';

interface ILoadingProps extends PropsWithChildren<any> {}

export const LoadingPage: React.FC<ILoadingProps> = () => {
    const themeContext = useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);

    return (
        <Modal
            titleAriaId={'login-modal'}
            isOpen={true}
            isBlocking={false}
            containerClassName={commonModalStyles(theme).container}
            isDarkOverlay={true}
        >
            <div className={commonModalStyles(theme).header}>
                <span id={'login-modal'}>Logging you in...</span>
            </div>
            <div className={commonModalStyles(theme).body}>
                <Spinner size={SpinnerSize.large} />
            </div>
        </Modal>
    );
};
